import React, { useEffect, Fragment, useState } from 'react'
import get from 'lodash/get'
import { getCustomAttributes } from 'action_creators/custom_attribute'
import { getUserDetails } from 'action_creators/user'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import Tooltip from 'britive-design-system/core/components/tooltip'
import { SubordinatesList } from './subordinatesList'
import listIcon from 'static/images/listIcon.svg'
import { isEmpty } from 'lodash'

const Wrapper = styled.div`
  padding: 20px 0;
`

const Table = styled.table`
  background: #fff;
  margin-bottom: 16px;

  tr {
    border-top: 1px solid #f3f3f3;
    border-bottom: 1px solid #f3f3f3;
    border-right: 1px solid #f3f3f3;
  }

  td {
    padding: 10px;
    border-left: 1px solid #f3f3f3;
    min-width: 320px;

    > span {
      width: 100%;
      display: flex;
    }

    &:first-child {
      text-transform: capitalize;
      font-weight: 600;
    }
  }
`
const CSS_CLASSNAME_PREFIX = 'register-verification-device-container'
const style = {
  subordinate: {
    cursor: 'pointer',
    alignItems: 'center',
    gap: '10px',
  },
}

function ViewUserDetails({ user, dispatch, customAttributes }) {
  const [managerDetails, setManagerDetails] = useState('')
  const [openSubordinateModal, setOpenSubordinateModal] = useState(false)
  const [subordinateDetails, setSubordinateDetails] = useState({
    id: null,
    name: '',
  })

  useEffect(() => {
    user.type === 'User' && dispatch(getCustomAttributes())
  }, [])

  useEffect(() => {
    const managerId = user?.managerId
    if (managerId) {
      dispatch(getUserDetails(managerId))
        .then(res => {
          const manager = res?.value?.data?.[0]
          if (manager) {
            setManagerDetails(manager)
          }
        })
        .catch(err => {
          console.error(err)
        })
    }
  }, [user?.managerId, dispatch])

  return (
    <Wrapper>
      <div>
        <Table>
          <tbody>
            {user.type === 'ServiceIdentity' ? (
              <Fragment>
                <tr>
                  <td>Name</td>
                  <td>{user.name}</td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>{user.description}</td>
                </tr>
              </Fragment>
            ) : (
              <Fragment>
                <tr>
                  <td>First Name</td>
                  <td>{user.firstName}</td>
                </tr>
                <tr>
                  <td>Last Name</td>
                  <td>{user.lastName}</td>
                </tr>
                <tr>
                  <td>Primary email</td>
                  <td>{user.email}</td>
                </tr>
                <tr>
                  <td>Username</td>
                  <td>
                    <span style={style.subordinate}>
                      {user?.username}
                      {!isEmpty(user?.username) && (
                        <>
                          <Tooltip title={'View Direct Reports'} position="top">
                            <img
                              className={`${CSS_CLASSNAME_PREFIX}-action-icon`}
                              src={listIcon}
                              onClick={() => {
                                setSubordinateDetails({
                                  id: user?.userId,
                                  name: `${user?.firstName} ${user?.lastName}`.trim(),
                                })
                                setOpenSubordinateModal(true)
                              }}
                            />
                          </Tooltip>
                        </>
                      )}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Mobile number</td>
                  <td>{user.mobile}</td>
                </tr>
                <tr>
                  <td>Phone number</td>
                  <td>{user.phone}</td>
                </tr>
                <tr>
                  <td>Manager</td>
                  <td>
                    <span style={style.subordinate}>
                      {managerDetails?.firstName} {managerDetails?.lastName}
                      {!isEmpty(managerDetails) && (
                        <>
                          <Tooltip title={'View Direct Reports'} position="top">
                            <img
                              className={`${CSS_CLASSNAME_PREFIX}-action-icon`}
                              src={listIcon}
                              onClick={() => {
                                setSubordinateDetails({
                                  id: managerDetails?.id,
                                  name: `${managerDetails?.firstName} ${managerDetails?.lastName}`.trim(),
                                })
                                setOpenSubordinateModal(true)
                              }}
                            />
                          </Tooltip>
                        </>
                      )}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Identity Provider</td>
                  <td>{get(user, 'identityProvider.name')}</td>
                </tr>
                {customAttributes.map(
                  customAttribute =>
                    !customAttribute.builtIn && (
                      <tr key={customAttribute.id}>
                        <td>{customAttribute.name}</td>
                        <td>
                          {get(user, 'attributes', []).map(
                            (attribute, index) =>
                              attribute.attributeId === customAttribute.id && (
                                <span key={`${customAttribute.id}${index}`}>
                                  {customAttribute.dataType === 'Boolean'
                                    ? attribute.attributeValue === 'true'
                                      ? 'Yes'
                                      : 'No'
                                    : attribute.attributeValue}
                                </span>
                              )
                          )}
                        </td>
                      </tr>
                    )
                )}
              </Fragment>
            )}
          </tbody>
        </Table>
        <SubordinatesList
          open={openSubordinateModal}
          onClose={() => setOpenSubordinateModal(false)}
          id={subordinateDetails?.id}
          name={subordinateDetails?.name}
        />
      </div>
    </Wrapper>
  )
}

const mapStateToProps = state => {
  const { customAttributes, user } = state
  return {
    fetching: customAttributes.fetchingCustomAttributes,
    customAttributes: customAttributes.customAttributes,
    currentUserId: user.userId,
  }
}

const withConnect = connect(mapStateToProps)

export default compose(withConnect, withRouter)(ViewUserDetails)
